import React from 'react';
import type { BuilderSection } from 'types/websiteBuilder';
import SectionWrapper from './SectionWrapper';
import styles from './Canvas.module.scss';

interface CanvasProps {
  sections: BuilderSection[];
  previewMode: boolean;
  onSelectSection: (id: string | null) => void;
  onUpdateSectionData: (id: string, data: Record<string, unknown>) => void;
}

function Canvas({
  sections,
  previewMode,
  onSelectSection,
  onUpdateSectionData,
}: CanvasProps) {
  const sorted = [...sections].sort((a, b) => a.order - b.order);
  const secondSection = sorted[1];
  const sliderIsSecond = secondSection?.type === 'marquee';

  return (
    <div className={styles.canvas}>
      {sorted.length === 0 ? (
        <p className={styles.emptyState}>
          No sections yet. Click a template on the left to add one.
        </p>
      ) : (
        sorted.map((section, index) => {
          const previousSection = index > 0 ? sorted[index - 1] : null;
          const sliderAfter = previousSection?.type === 'marquee';
          const sliderAfterHero =
            previousSection?.type === 'hero' && section.type === 'marquee';
          const navigationTilesAfter =
            previousSection?.type === 'navigationTiles';
          const campaignHeroAfter = previousSection?.type === 'campaignHero';
          const teamAfterMediaSection =
            section.type === 'team' &&
            (previousSection?.type === 'marquee' ||
              previousSection?.type === 'gallery');
          const galleryAfterTeam =
            section.type === 'gallery' && previousSection?.type === 'team';
          const ctaAfterTeam =
            section.type === 'cta' && previousSection?.type === 'team';

          return (
            <SectionWrapper
              key={section.id}
              section={section}
              previewMode={previewMode}
              stickyTop={section.type === 'header'}
              avoidSliderCampaignHeroGap={
                sliderAfter && section.type === 'campaignHero'
              }
              avoidStickyOverlay={
                section.type !== 'hero' &&
                (navigationTilesAfter ||
                  sliderAfterHero ||
                  ctaAfterTeam ||
                  (campaignHeroAfter && section.type !== 'navigationTiles') ||
                  (sliderIsSecond && section.id === secondSection.id))
              }
              avoidHeaderBodyGap={
                previousSection?.type === 'header' && section.type === 'body'
              }
              avoidPreviousOverlap={teamAfterMediaSection || galleryAfterTeam}
              onSelect={() => onSelectSection(section.id)}
              onUpdateData={(data) => onUpdateSectionData(section.id, data)}
            />
          );
        })
      )}
    </div>
  );
}

export default Canvas;
